<template>
  <div class="fixed-btn">
    <div class="list-add-btn" @click.prevent="agregar" v-if="agregarHabilitado">
        <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
    </div>
    <div class="abm-save-btn" @click.prevent="save">
        <i class="fa fa-save fa-2x" aria-hidden="true"></i>
    </div>
    <div class="abm-cancel-btn" @click.prevent="cancel">
        <i class="fa fa-close fa-2x" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'abmButtonsPresupuestosInternos',
  props: {
    agregarHabilitado: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    save() {
      this.$emit('save');
    },
    cancel() {
      this.$emit('cancel');
    },
    agregar() {
      this.$emit('agregar');
    }
  },
}
</script>

<style>
</style>
